import React from "react";
import PropTypes from "prop-types";

const POPULAR = ["arrow", "user", "home", "cart", "heart", "mail", "settings", "phone"];

/**
 * Shown when a search finds nothing. If the style filter hid the matches it offers to
 * show every style; otherwise it suggests shorter queries and popular searches.
 */
export const SearchEmpty = ({ query, styleLabel, hiddenByStyle, partials, onSearch, onShowAllStyles }) => (
  <div className="empty-state" role="status">
    <div className="empty-state__art" aria-hidden="true">
      <svg width="40" height="40" viewBox="0 0 32 32" fill="none">
        <path
          d="M14.667 25.333c5.89 0 10.666-4.775 10.666-10.666S20.558 4 14.667 4 4 8.776 4 14.667c0 5.89 4.776 10.666 10.667 10.666ZM28 28l-5.8-5.8M11.5 11.5l6.333 6.333M17.833 11.5 11.5 17.833"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>

    {hiddenByStyle > 0 ? (
      <React.Fragment>
        <h3>No {styleLabel.toLowerCase()} icons for “{query}”</h3>
        <p>
          {hiddenByStyle} {hiddenByStyle === 1 ? "icon matches" : "icons match"} in other styles.
        </p>
        <div className="empty-state__actions">
          <button type="button" className="btn btn-primary" onClick={onShowAllStyles}>
            Show all styles
          </button>
          <button type="button" className="btn btn-outline-primary" onClick={() => onSearch("")}>
            Clear search
          </button>
        </div>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <h3>No icons for “{query}”</h3>
        <p>Check the spelling, or try a shorter, more general word.</p>

        {partials.length > 0 ? (
          <div className="empty-state__group">
            <span className="empty-state__label">Search for</span>
            <ul className="empty-state__chips">
              {partials.map(({ term, count }) => (
                <li key={term}>
                  <button type="button" onClick={() => onSearch(term)}>
                    {term}
                    <span>{count}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ) : null}

        <div className="empty-state__group">
          <span className="empty-state__label">Popular</span>
          <ul className="empty-state__chips">
            {POPULAR.filter((term) => !partials.some((p) => p.term === term)).map((term) => (
              <li key={term}>
                <button type="button" onClick={() => onSearch(term)}>
                  {term}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="empty-state__actions">
          <button type="button" className="btn btn-outline-primary" onClick={() => onSearch("")}>
            Clear search
          </button>
        </div>
      </React.Fragment>
    )}
  </div>
);

SearchEmpty.propTypes = {
  query: PropTypes.string.isRequired,
  styleLabel: PropTypes.string,
  hiddenByStyle: PropTypes.number,
  // Single words from a multi-word query that do find icons, with how many
  partials: PropTypes.arrayOf(PropTypes.shape({ term: PropTypes.string, count: PropTypes.number })),
  onSearch: PropTypes.func.isRequired,
  onShowAllStyles: PropTypes.func.isRequired,
};

SearchEmpty.defaultProps = {
  styleLabel: "",
  hiddenByStyle: 0,
  partials: [],
};

export default SearchEmpty;
